import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GLMMaterialDesignModule} from '../material-design/material-design.module';
import {NavBarComponent} from './nav-bar.component';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    GLMMaterialDesignModule
  ],
  declarations: [
    NavBarComponent
  ],
  exports: [
    NavBarComponent
  ]
})

export class NavBarModule {
}
